import { render, staticRenderFns } from "./gallery_index.vue?vue&type=template&id=a0680a0a&scoped=true&"
import script from "./gallery_index.vue?vue&type=script&lang=js&"
export * from "./gallery_index.vue?vue&type=script&lang=js&"
import style0 from "./gallery_index.vue?vue&type=style&index=0&id=a0680a0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0680a0a",
  null
  
)

export default component.exports